import { render, staticRenderFns } from "./edit-exam-confirmation-modal.vue?vue&type=template&id=2fb94889&scoped=true"
import script from "./edit-exam-confirmation-modal.vue?vue&type=script&lang=js"
export * from "./edit-exam-confirmation-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-exam-confirmation-modal.vue?vue&type=style&index=0&id=2fb94889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb94889",
  null
  
)

export default component.exports